function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1738",
  "data-name": "Rounded Rectangle 1738",
  className: "cls-1",
  d: "M49,145h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H49a2,2,0,0,1-2-2v-5A2,2,0,0,1,49,145Zm2,2h2a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H51a2,2,0,0,1-2-2v-1A2,2,0,0,1,51,147Z",
  transform: "translate(-35 -145)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1738-2",
  "data-name": "Rounded Rectangle 1738",
  className: "cls-1",
  d: "M49,156h6a2,2,0,0,1,2,2v10a2,2,0,0,1-2,2H49a2,2,0,0,1-2-2V158A2,2,0,0,1,49,156Zm2,2h2a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H51a2,2,0,0,1-2-2v-6A2,2,0,0,1,51,158Z",
  transform: "translate(-35 -145)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1738-3",
  "data-name": "Rounded Rectangle 1738",
  className: "cls-1",
  d: "M37,161h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H37a2,2,0,0,1-2-2v-5A2,2,0,0,1,37,161Zm2,2h2a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H39a2,2,0,0,1-2-2v-1A2,2,0,0,1,39,163Z",
  transform: "translate(-35 -145)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1738-4",
  "data-name": "Rounded Rectangle 1738",
  className: "cls-1",
  d: "M37,145h6a2,2,0,0,1,2,2v10a2,2,0,0,1-2,2H37a2,2,0,0,1-2-2V147A2,2,0,0,1,37,145Zm2,2h2a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H39a2,2,0,0,1-2-2v-6A2,2,0,0,1,39,147Z",
  transform: "translate(-35 -145)"
});

function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.89d0965c.svg";
export { ForwardRef as ReactComponent };